import React, { Component } from "react";
import PropTypes from "proptypes";

//TODO: get Endorsement Letter link, current not fully functioning

export default class FundRaiseSideBar extends Component {
  componentDidMount() {}
  render() {
    return (
      <div className="fundraise">
        <h4 className="h1-style muted">Refer-and-save & your Fundraising Toolkit</h4>
        <p>
          Join our <strong>Refer-A-Friend Program</strong> and you and your friend(s) can both earn discounts off your trip (we emailed you info on how to join!).
          </p>
          <p>
          Most travelers fundraise for a portion or their entire trip! Here's a <strong>Fundraising Toolkit</strong> with resources 
          that past travelers have used to raise money and an Endorsement Letter from GIVE!
        </p>
        <ul>
          <li>
            <a
              href="https://www.givevolunteers.org/fundraising-toolkit/"
              rel="noopener noreferrer"
              target="_blank"
              className="small-link"
            >
              Your Fundraising Toolkit
            </a>
          </li>
          <li>
            <a
              href={`https://givevolunteers.secure.force.com/pmtx/EndorsementPDF?oid=${
                this.props.tripId
              }&cid=${this.props.userId}`}
              rel="noopener noreferrer"
              target="_blank"
              className="small-link"
            >
              Fundraising Endorsement Letter
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

FundRaiseSideBar.propTypes = {
  userId: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired
};

FundRaiseSideBar.defaultProps = {
  userId: "",
  tripId: ""
};
